// Generated from api/openapi/federation.yaml by make docs. Do not edit.
import { z } from "zod";

export const scimSyncLogEntrySchema = z.object({
  "id": z.string().uuid(),
  "operation": z.enum(["create", "update", "patch", "delete"]),
  "resource_type": z.enum(["User", "Group"]),
  "resource_id": z.string().uuid().optional(),
  "external_id": z.string().optional(),
  "resource_name": z.string().optional(),
  "response_status": z.number().int(),
  "error_detail": z.string().optional(),
  "created_at": z.string().datetime({ offset: true }),
  "token_id": z.string().uuid().optional(),
  "token_description": z.string().optional()
}).strict();

export const scimPaginationSchema = z.object({
  "total": z.number().int().min(0),
  "offset": z.number().int().min(0),
  "limit": z.number().int().min(1)
}).strict();

export const scimOperationsSchema = z.object({
  "health": z.enum(["healthy", "warning", "inactive"]),
  "last_activity": z.string().datetime({ offset: true }).optional(),
  "summary_24h": z.object({
    "created": z.number().int().min(0),
    "updated": z.number().int().min(0),
    "deactivated": z.number().int().min(0),
    "errors": z.number().int().min(0),
    "total": z.number().int().min(0)
  }).strict(),
  "recent_log": z.array(scimSyncLogEntrySchema),
  "pagination": scimPaginationSchema
}).strict();
